import { camelizeKeys } from "humps";
import { assoc, equals, map } from "ramda";
import { TrackJS } from "trackjs";

import { BRAND_BUCKET } from "api_urls";
import { ENV } from "app_constants";
import { getPrettyUrl } from "get_base_uri";
import {
  checkStatus,
  cloudfrontGetRequest,
  parseJSON,
} from "helpers/ajax_request";
import { reportError } from "helpers/error_reporting/error_reporting";
import getStoreInfo from "interfaces/store_info";
import formatBrandInfo from "packages/loyalty/api/helpers/brand_info_transform";

function getBrandAndStoreInfo(callback, brandPrettyUrl = getPrettyUrl()) {
  return fetch(
    `${BRAND_BUCKET}/${brandPrettyUrl}/brand.json`,
    cloudfrontGetRequest()
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys)
    .then(formatBrandInfo)
    .then(brandInfo => {
      /** @type {string[]} */
      const storePrettyUrls = brandInfo.stores;
      const storeRequests = map(
        storePrettyUrl => getStoreInfo(null, storePrettyUrl),
        storePrettyUrls
      );

      Promise.all(storeRequests).then(stores => {
        callback(assoc("stores", stores, brandInfo));
      });
    })
    .catch(error => {
      // if we aren't getting a brand back it either
      // doesn't exist or AWS is down
      reportError(error);
      if (equals(ENV, "production")) {
        window.location.href = "http://upserve.com";
      }
    });
}

function getBrandInfo(brandPrettyUrl = getPrettyUrl()) {
  return fetch(
    `${BRAND_BUCKET}/${brandPrettyUrl}/brand.json`,
    cloudfrontGetRequest()
  )
    .then(checkStatus)
    .then(parseJSON)
    .then(camelizeKeys)
    .then(formatBrandInfo)
    .catch(error => {
      // if we aren't getting a brand back it either
      // doesn't exist or AWS is down
      TrackJS.track(error);
      if (equals(ENV, "production")) {
        window.location.href = "http://upserve.com";
      }
    });
}

export { getBrandInfo, getBrandAndStoreInfo };
